<template>
    <section class="client-wrapper pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="section-title text-center mb-30px">Our Clients</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <client-slider :items="items" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ClientSlider from '../pieces/ClientSlider.vue'

export default {
    name: 'ClientSection',
    components: {
        ClientSlider
    },
    data() {
        return {
            items: [
                require('@/assets/images/envato.png'),
                require('@/assets/images/envato-2.png'),
                require('@/assets/images/envato.png'),
                require('@/assets/images/envato-2.png'),
                require('@/assets/images/envato.png'),
                require('@/assets/images/envato-2.png')
            ]
        }
    }
}
</script>